(() => {
function init(root) {
 if (root.dataset.packPricingReady) return;
 root.dataset.packPricingReady = 'true';
 const radios = [...root.querySelectorAll('input[name="box_size"],input[type="radio"][name="id"]')];
 const count = radio => Number(radio.name === 'box_size' ? radio.value : radio.dataset.count);
 const render = () => { const selected = radios.find(r => r.checked); if (!selected) return; root.querySelectorAll('[data-pack-for]').forEach(p => p.hidden = Number(p.dataset.packFor) !== count(selected)); };
 root.addEventListener('change', render);
 root.querySelectorAll('[data-upgrade-count]').forEach(button => button.addEventListener('click', () => {
  const radio = radios.find(r => count(r) === Number(button.dataset.upgradeCount));
  if (!radio || radio.disabled || radio.dataset.available !== 'true') return;
  radio.checked = true; radio.dispatchEvent(new Event('change', {bubbles: true})); radio.focus(); render();
 }));
 render();
}
document.querySelectorAll('[data-box-builder],[data-rtd]').forEach(init);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-box-builder],[data-rtd]').forEach(init));
})();
